import styled, { css } from 'styled-components';
import { IconMobileCheck } from '@/app/common/icons/libraryIcons';
import { URLParameters } from '@/app/common/urlParameters';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useTranslation } from '../../translations/Translation';
import getSearchParams from '../../search/common/getSearchParams';

type IconProps = {
  imageBasePath: string;
};

const Badge = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  border-radius: 4px;
  min-height: 28px;
  padding: 4px 8px;
  width: fit-content;
  font-style: normal;
  ${(p) => p.theme.kallisto.mixins.font('BodySmall')};
  color: ${(p) => p.theme.kallisto.color.text.static.textOnDark};
`;

const BadgeWithBackgroundImage = styled(Badge)`
  padding-left: 30px;
  background-repeat: no-repeat;
  background-position: 8px center;
  background-size: 16px;
`;

const StyledMobileRatesBadge = styled(Badge)`
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
  color: ${({ theme }) => theme.kallisto.color.text.static.textBrandContrastPrimary};
`;

const StyledMyPriceBadge = styled(BadgeWithBackgroundImage)<IconProps>`
  background-image: ${({ imageBasePath }) => `url('${imageBasePath}icons/my_price_white.svg')`};
  background-color: ${(p) => p.theme.kallisto.color.common.special.myPrice[500]};
`;

const StyledEmployeeDiscountBadge = styled(Badge)`
  background-color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimarySelected};
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  gap: 8px;
`;

export const MyPriceBadge = () => {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  const { imageBasePath } = localization;

  return (
    <StyledMyPriceBadge
      dangerouslySetInnerHTML={{ __html: t('vacation.oss.cards.myprice_label_html') }}
      imageBasePath={imageBasePath}
    />
  );
};

export const MobileRatesBadge = () => {
  const { t } = useTranslation();
  const searchParams = getSearchParams();
  const isApp = searchParams[URLParameters.APP];
  return (
    <StyledMobileRatesBadge>
      <IconMobileCheck
        css={css`
          height: 1rem;
          width: 1rem;
          margin-right: 8px;
        `}
      />
      <div>{t(isApp ? 'vacation.select.details.app_only_price' : 'vacation.oss.cards.mobile_only_price')}</div>
    </StyledMobileRatesBadge>
  );
};

export const EmployeeDiscountBadge = () => {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  const { imageBasePath } = localization;

  return (
    <StyledEmployeeDiscountBadge>
      <img src={`${imageBasePath}icons/pinkpeople.svg`} alt="pink people discount" width="14px" height="14px" />
      <div>{t('vacation.oss.cards.pinkpeople_label_html')}</div>
    </StyledEmployeeDiscountBadge>
  );
};
